/**
 * The tabs of a device's page. Each value is the URL segment after
 * `/devices/:deviceId` that opens the tab: `DevicesRoutes` registers the tab's
 * route at that segment, `Goto.createDeviceRoute` links to it, and the tab
 * strip reads it back to mark the active tab.
 */
export enum DeviceTab {
  Overview = "overview",
  Sessions = "sessions",
  Datasets = "datasets",
  Metrics = "metrics",
  Configurations = "configurations",
  Tokens = "tokens",
  Details = "details",
}
